import * as R from "ramda";
import React, {Component} from "react";
import FlexView from "react-flexview";
import Button from "../../../../../modules/commons/Button";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import SimpleDate from "../../../../../modules/SimpleDate";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import {formGroupReceivingKSU, modalContentConfig, tabTableConfig} from "../config/config";
import InventoryCreateUpdate from "./inventoryCreateUpdate";
import InventoryDetail from "./inventoryDetail";
import InventoryFilter from "./inventoryFilter";
import {flattenFormGroupObject, getValueFromDDL, mapToObjectDDL, removeNullFields} from "../../../../common/mapper";
import M from "moment/moment";
import Api from "../../../../../Services/Api";
import {defaultTableChange} from "../../../../../modules/custom/customTable";
import SimpleAlert from "../../../../../modules/popup/SimpleAlert";
import {contructQueryParam, getUserAccess} from "../../../../../Services/Utils";
import SimpleLoadingOverlay from "../../../../../modules/popup/SimpleLoadingOverlay";
import ErrorAction from "../../../../../Redux/ErrorRedux";
import {connect} from "react-redux";
import { HttpStatus } from "../../../../common/Constants";
import { saveAs } from "file-saver";

class InventoryContent extends Component {
    constructor(props) {
        super(props);
        this.tabTableConfig = tabTableConfig[props.tab];
        this.tableColumns = [
            {
                name: "id",
                label: "No",
                options: {
                    customBodyRender: (_, tableMeta) => {
                        const {page, rowsPerPage} = tableMeta.tableState;
                        const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                        return <>{rowNumber}</>;
                    },
                    sort: false,
                },
            },
            {
                name: this.tabTableConfig.dateName,
                label: this.tabTableConfig.dateLabel,
                options: {
                    sort: false,
                },
            },
            {
                name: this.tabTableConfig.noName,
                label: this.tabTableConfig.noLabel,
                options: {
                    sort: false,
                },
            },
            {
                name: "noSpbm",
                label: "No. SPBM",
                options: {
                    sort: false,
                },
            },
            {
                name: "tglSpbm",
                label: "Tanggal SPBM",
                options: {
                    sort: false,
                },
            },
            {
                name: "getTotalData",
                label: "Jumlah",
                options: {
                    sort: false,
                },
            },
            {
                name: "catatan",
                label: "Catatan",
                options: {
                    sort: false,
                },
            },
            {
                name: "",
                label: "Aksi",
                options: {
                    customBodyRender: (_, tableMeta) => {
                        return (
                            <Button
                                className="btnAct"
                                onClick={() =>
                                    this.handleModalDetailVisibility(tableMeta.rowIndex)
                                }
                            >
                                <i
                                    className="fa fa-lg fa-eye"
                                    style={{
                                        fontSize: 20,
                                        color: "red"
                                    }}
                                />
                            </Button>
                        );
                    },
                    sort: false,
                },
            },
        ];
        this.initialSearch = {
            startSPBK: M(new Date()).format("DD-MM-YYYY"),
            endSPBK: M(new Date()).format("DD-MM-YYYY"),
        };
        this.initialFilterData = {
            startSPBK: null,
            endSPBK: null,
            startSPBM: null,
            endSPBM: null,
            noSPBK: null,
            noSPBM: null,
            kodeKSU: null,
            kategoriKSU: null,
            idLocator: null,
        }
        this.state = {
            userAccess: null,
            loading: false,
            alertSavedModalVisible: false,
            modalCreateDataVisible: false,
            filterModalVisible: false,
            detailModalVisible: false,
            selectedData: null,
            selectedCabang: null,
            fetchingTableData: false,
            search: this.initialSearch,
            filterData: this.initialFilterData,
            dataCabang: [],
            dataTable: [],
            pagination: {
                count: 10,
                limit: 5,
                page: 1,
                orderBy: "id",
                sort: "ASC",
            }
        };
    }

    async componentDidMount() {
        await this.fetchDataCabang();
        await this.initialFetchData();
    }

    handleResetPagination = () =>{
      this.setState((prev) => ({
        ...prev,
        pagination: {
          totalData: 0,
          page: 1,
          limit: 5,
        },
      }));
    }

    initialFetchData = async () => {
        this.handleTriggerLoading()
        await this.fetchData({
            ...removeNullFields(this.parseFilterData(this.state.search)),
            ...this.initialSearch,
            limit: this.state.pagination.limit,
            page: 1,
        });
        this.handleTriggerLoading()
    };

    handleChangeKodeCabang = async (kodeCabang) => {
        this.handleTriggerLoading();
        this.handleResetPagination()
        await this.fetchData({
            kodeCabang,
            limit: this.state.pagination.limit,
            page: 1,
             ...this.initialSearch,
        });
        this.setState((prevState) => ({
            ...prevState,
            userAccess: getUserAccess(this.props.menuAccess, this.state.search.kodeCabang.value),
            search: {
                ...prevState.search,
                ...this.initialSearch,
            },
        }));
        this.handleTriggerLoading();
    };

    handleModalFilterVisibility = () => {
        this.setState((prevState) => ({
            ...prevState,
            selectedCabang: this.state.search.kodeCabang,
            filterModalVisible: !prevState.filterModalVisible,
        }));
    };

    handleModalDetailVisibility = (index) => {
        if (!R.isNil(index)) {
            const dataTableState = [...this.state.dataTable];
            const selectedData = dataTableState[index];
            this.setState((prevState) => ({
                ...prevState,
                selectedData,
                selectedCabang: this.state.search.kodeCabang,
                detailModalVisible: !prevState.detailModalVisible,
            }));
            return;
        }

        this.setState((prevState) => ({
            ...prevState,
            selectedData: null,
            detailModalVisible: !prevState.detailModalVisible,
        }));
    };

    handleModalCreateVisibility = () => {
        this.setState((prevState) => ({
            ...prevState,
            selectedCabang: this.state.search.kodeCabang,
            modalCreateDataVisible: !prevState.modalCreateDataVisible,
        }));
    };

    handleAlertSavedModalVisibility = () => {
        this.setState((prevState) => ({
            ...prevState,
            alertSavedModalVisible: !prevState.alertSavedModalVisible,
        }))
    }

    handleInputDateChange = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            search: {
                ...prevValue.search,
                [name]: M(value).format("DD-MM-YYYY"),
            },
        }));
    };

    handleSearchValueChange = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            search: {
                ...prevValue.search,
                [name]: value,
            },
        }));
        if (R.equals(name, "kodeCabang")) this.handleChangeKodeCabang(value.value);
    };

    handleFilterValueChange = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            filterData: {
                ...prevValue.filterData,
                [name]: value,
            },
        }));
    };

    handleOnSubmitSearch = async () => {
        try {
            this.handleTriggerLoading()
            // this.handleResetPagination()
            await this.fetchData({
                ...removeNullFields(this.parseFilterData(this.state.search)),
                limit: this.state.pagination.limit,
                page: 1
            });
            this.handleClearFilter();
            this.handleTriggerLoading()
        } catch (error) {
            console.log("errors: ", error);
        }
    }

    handleSubmitFilter = async () => {
        try {
            this.handleTriggerLoading();
            // this.handleResetPagination()
            await this.fetchData({
                ...removeNullFields(this.parseFilterData(this.state.filterData)),
                kodeCabang: this.state.search.kodeCabang.value,
                limit: this.state.pagination.limit,
                page: 1
            });
        } catch (error) {
            console.log("error: ", error);
        } finally {
            this.handleTriggerLoading();
            this.handleClearSearch();
            this.handleModalFilterVisibility();
        }
    };

    handleClearFilter = () => {
        this.setState((prevState) => ({
            ...prevState,
            filterData: {
                ...prevState.filterData,
                ...this.initialFilterData
            },
        }));
    }

    handleClearSearch = () => {
        this.setState((prevState) => ({
          ...prevState,
          search: {
            ...prevState.search,
            startSPBK: null,
            endSPBK: null,
          },
        }));
    }

    handleOnSubmit = async (action, data, list) => {
        try {
            this.handleTriggerLoading();
            const formGroup = flattenFormGroupObject(data);
            const requestBody = {
                ...formGroup,
                listRequestDetailKsu: list,
                idSupplier: getValueFromDDL(formGroup, "idSupplier"),
                idSupplierExpedisi: getValueFromDDL(formGroup, "idSupplierExpedisi"),
                kodeCabang: getValueFromDDL(formGroup, "kodeCabang"),
            };

            await Api.create("NAGAMAS_TRANSACTION").submitReceivingKSU(requestBody)
        } catch (error) {
            console.log("errors: ", error);
        } finally {
            // this.setState((prevState) => ({
            //     ...prevState,
            //     search: {
            //         ...prevState.search,
            //         ...this.initialSearch,
            //     },
            // }));
            // this.handleResetPagination()
            // await this.fetchData({
            //     ...removeNullFields(this.parseFilterData(this.state.search)),
            //     limit: this.state.pagination.limit,
            //     page: 1
            // });
            await this.handleRefetchAfterProcess();

            if (action === "save") {
                this.handleModalCreateVisibility();
            } else {
                this.handleModalDetailVisibility();
            }

            this.handleAlertSavedModalVisibility();
            this.handleTriggerLoading();
        }
    }

    handleOnDelete = async (param) => {
        try {
            this.handleTriggerLoading();
            // this.handleResetPagination()
            await Api.create("NAGAMAS_TRANSACTION").deleteReceivingKSU(contructQueryParam({
                spbkNo: param,
            }));
            // await this.fetchData({
            //     ...removeNullFields(this.parseFilterData(this.state.search)),
            //     limit: this.state.pagination.limit,
            //     page: 1
            // });
            await this.handleRefetchAfterProcess();
            this.handleModalDetailVisibility();
            this.handleTriggerLoading();
        } catch (error) {
            console.log("errors: ", error);
        }
    }

    handlePrint = async () => {
        this.handleTriggerLoading()
        try {
            const res = await Api.create("NAGAMAS_TRANSACTION_FILE").downloadReceivingKSUExcel({
              startSPBK: this.state.search.startSPBK,
              endSPBK: this.state.search.endSPBK,
              kodeCabang: this.state.search.kodeCabang?.value,
              limit: null,
              page: null,
            });
            console.log(res)
            if(res.ok){
                const blob = new Blob([res.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
                saveAs(blob, 'RECEIVING_KSU.xlsx')
            }
        } catch (error) {
            console.log(error)
        }
        this.handleTriggerLoading()
    }

    handleChangePage = async (tableState) => {
        this.handleTriggerLoading();
        let limit = tableState.rowsPerPage;
        let page = tableState.page + 1;
        this.setState((prevValue) => ({
            ...prevValue,
            pagination: {
                ...prevValue.pagination,
                page: page,
                limit: limit,
            },
        }));

        const filterRequest = removeNullFields(this.parseFilterData(this.state.filterData))
        const searchRequest = removeNullFields(this.parseFilterData(this.state.search))

        let paramFilters;
        if (!R.isEmpty(filterRequest)) {
            paramFilters = {...filterRequest, kodeCabang: this.state.search.kodeCabang.value};
        } else {
            paramFilters = {...searchRequest};
        }

        await this.fetchData({
            ...paramFilters,
            page: page,
            limit: limit
        });
        this.handleTriggerLoading();
    }

    handleChangeRowsPerPage = async (tableState) => {
        this.handleTriggerLoading();
        let limit = tableState.rowsPerPage;
        this.setState((prevValue) => ({
            ...prevValue,
            pagination: {
                ...prevValue.pagination,
                count: 1,
                page: 1,
                limit: limit,
            }
        }));

        const filterRequest = removeNullFields(this.parseFilterData(this.state.filterData))
        const searchRequest = removeNullFields(this.parseFilterData(this.state.search))

        let paramFilters;
        if (!R.isEmpty(filterRequest)) {
            paramFilters = {...filterRequest, kodeCabang: this.state.search.kodeCabang.value};
        } else {
            paramFilters = {...searchRequest};
        }

        await this.fetchData({
            ...paramFilters,
            page: 1,
            limit: limit
        });
        this.handleTriggerLoading();
    }

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: !prevValue.loading,
        }));
    };

    fetchData = async (body) => {
        try {
            let res = await Api.create("NAGAMAS_TRANSACTION").getAllReceivingKSUByParam(
                body && Object.keys(body).length > 0 ?
                    body :
                    {page: 1, limit: 5}
            );

            if (res.ok && res.data.status === HttpStatus.SUCCESS) {
                this.setState((prevValue) => ({
                    ...prevValue,
                    dataTable: res.data.data,
                    pagination: {
                        ...prevValue.pagination,
                        count: res.data.totalData ? res.data.totalData : 5,
                    },
                }));
            }
        } catch (e) {
            console.log("errors: ", e);
        }
    }

    fetchDataCabang = async () => {
        try {
            let res = await Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang();
            if (res.ok && res.data.status === HttpStatus.SUCCESS) {
                let filteredData = res.data.data.filter(
                    item => this.props.menuAccess.map(data => data.idRefObj).includes(item.kodeCabang)
                );

                if (filteredData.length !== 0) {
                    this.setState((prevValue) => ({
                        ...prevValue,
                        dataCabang: filteredData,
                        search: {
                            ...prevValue.search,
                            kodeCabang: mapToObjectDDL(filteredData[0].namaDealer, filteredData[0].kodeCabang),
                        },
                        userAccess: getUserAccess(this.props.menuAccess, filteredData[0].kodeCabang),
                    }));
                }
            }
        } catch (error) {
            console.log("errors: ", error);
        }
    }

    parseFilterData(data) {
        return {
            ...data,
            kodeCabang: getValueFromDDL(data, "kodeCabang"),
            kodeKSU: getValueFromDDL(data, "kodeKSU"),
            kategoriKSU: getValueFromDDL(data, "kategoriKSU"),
            idLocator: getValueFromDDL(data, "idLocator"),
        };
    }

    handleRefetchAfterProcess = async () => {
        const filterRequest = removeNullFields(this.parseFilterData(this.state.filterData))
        const searchRequest = removeNullFields(this.parseFilterData(this.state.search))

        let paramFilters;
        if (!R.isEmpty(filterRequest)) {
            paramFilters = {...filterRequest, kodeCabang: this.state.search.kodeCabang.value};
        } else {
            paramFilters = {...searchRequest};
        }

        await this.fetchData({
            ...paramFilters,
            page: this.state.pagination.page,
            limit: this.state.pagination.limit
        });
    }

    render() {
        return (
            <>
                <FlexView
                    style={{justifyContent: "space-between"}}
                    vAlignContent="center"
                    className="margin-top-5px"
                >
                    <FlexView vAlignContent="center" style={{gap: "10px"}}>
                        <SimpleDDL
                            id="select_options_nama_cabang"
                            box="search"
                            name="kodeCabang"
                            containerclassname="width width-250px"
                            placeholder="Nama Cabang"
                            menuPosition="fixed"
                            options={
                                this.state.dataCabang.map(
                                    item => mapToObjectDDL(item.namaDealer, item.kodeCabang)
                                )
                            }
                            value={this.state.search.kodeCabang}
                            onChange={(value, {name}) => this.handleSearchValueChange(name, value)}
                        />
                        <SimpleDate
                            id="select_date_from"
                            nextdate
                            date={this.state.search.startSPBK}
                            maxDate={this.state.search.endSPBK}
                            onChange={(value) => this.handleInputDateChange("startSPBK", value)}
                        />
                        <SimpleDate
                            id="select_date_to"
                            date={this.state.search.endSPBK}
                            onChange={(value) => this.handleInputDateChange("endSPBK", value)}
                        />
                        <SimpleButton
                            text="Cari"
                            className="margin-bottom-20px"
                            onClick={this.handleOnSubmitSearch}
                        />
                    </FlexView>
                    <SimpleButton
                        className={"btn background-red margin-bottom-20px"}
                        styles={{width: "unset"}}
                        onClick={this.handleModalFilterVisibility}
                        icon={<i className="fa fa-qrcode"></i>}
                    />
                </FlexView>
                <SimpleDataTable
                    data={this.state.dataTable}
                    columns={this.tableColumns}
                    options={{
                        ...defaultTableChange(
                            (tableState) => this.handleChangePage(tableState),
                            (tableState) => this.handleChangeRowsPerPage(tableState)
                        ),
                    }}
                    toCount={this.state.pagination.count}
                    rowsPerPage={this.state.pagination.limit}
                    page={this.state.pagination.page - 1}
                    footerAdditionalButtons={
                        <>
                            {this.state.userAccess && this.state.userAccess.createAccess && (
                                <SimpleButton
                                    onClick={() => this.handleModalCreateVisibility()}
                                    icon={<i className="fa fa-plus margin-right-10px"></i>}
                                    text={"Tambah Data"}
                                />
                            )}
                            <SimpleButton
                                onClick={() => this.handlePrint()}
                                icon={<i className="fa fa-lw fa-print margin-right-10px"></i>}
                                text={"Print"}
                            />
                        </>
                    }
                />

                {this.state.modalCreateDataVisible && (
                    <InventoryCreateUpdate
                        {...this.props}
                        tab={this.props.tab}
                        contentConfig={modalContentConfig[this.props.tab]}
                        formGroup={formGroupReceivingKSU}
                        initialValues={this.state.selectedData}
                        selectedCabang={this.state.selectedCabang}
                        visible={this.state.modalCreateDataVisible}
                        onSubmit={this.handleOnSubmit}
                        onClickClose={this.handleModalCreateVisibility}
                    />
                )}

                {this.state.filterModalVisible && (
                    <InventoryFilter
                        {...this.props}
                        tab={this.props.tab}
                        selectedCabang={this.state.selectedCabang}
                        filteredData={this.state.filterData}
                        visible={this.state.filterModalVisible}
                        onClearFilter={this.handleClearFilter}
                        onValueChange={this.handleFilterValueChange}
                        onSubmit={this.handleSubmitFilter}
                        onClickClose={this.handleModalFilterVisibility}
                    />
                )}

                {this.state.detailModalVisible && (
                    <InventoryDetail
                        {...this.props}
                        tab={this.props.tab}
                        formGroup={formGroupReceivingKSU}
                        initialValues={this.state.selectedData}
                        selectedCabang={this.state.selectedCabang}
                        userAccess={this.state.userAccess}
                        visible={this.state.detailModalVisible}
                        tableConfig={this.tabTableConfig}
                        onSubmit={this.handleOnSubmit}
                        onDelete={this.handleOnDelete}
                        onClickClose={this.handleModalDetailVisibility}
                    />
                )}

                {this.state.alertSavedModalVisible && (
                    <SimpleAlert
                        title={"Information"}
                        content={"Data telah disimpan."}
                        visible={this.state.alertSavedModalVisible}
                        onClickClose={this.handleAlertSavedModalVisibility}
                        additionalButtons={
                            <SimpleButton
                                type="button"
                                text="OK"
                                onClick={() => this.handleAlertSavedModalVisibility()}
                            />
                        }
                    />
                )}
                <SimpleLoadingOverlay active={this.state.loading}/>
            </>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setError: (payload) => dispatch(ErrorAction.setError(payload)),
    };
};

export default connect(null, mapDispatchToProps)(InventoryContent);
